import { addDays, format, isSameDay, parse } from "date-fns";
import { DAY_OFFSETS, FIELD_DATA } from "../constants/disputes.constant";
import { DEFAULT_YEAR_MONTH_DATE_FORMAT } from "constants/date-fns/dateTime.constant";

export const getDisputeDueDateOptions = () => {
  const today = new Date();
  let optionList = [
    {
      label: "Expired",
      value: [
        {
          name: `${FIELD_DATA.dispute_due_date}__lte`,
          value: format(
            addDays(today, DAY_OFFSETS.YESTERDAY),
            DEFAULT_YEAR_MONTH_DATE_FORMAT
          ),
        },
      ],
    },
    {
      label: "Due today",
      value: [
        {
          name: FIELD_DATA.dispute_due_date,
          value: format(today, DEFAULT_YEAR_MONTH_DATE_FORMAT),
        },
      ],
    },
    {
      label: "Due tomorrow",
      value: [
        {
          name: FIELD_DATA.dispute_due_date,
          value: format(
            addDays(today, DAY_OFFSETS.TOMORROW),
            DEFAULT_YEAR_MONTH_DATE_FORMAT
          ),
        },
      ],
    },
    {
      label: "Due within 7 days",
      value: [
        {
          name: `${FIELD_DATA.dispute_due_date}__lte`,
          value: format(today, DEFAULT_YEAR_MONTH_DATE_FORMAT),
        },
        {
          name: `${FIELD_DATA.dispute_due_date}__gte`,
          value: format(
            addDays(today, DAY_OFFSETS.WITHIN_WEEK),
            DEFAULT_YEAR_MONTH_DATE_FORMAT
          ),
        },
      ],
    },
  ];

  return optionList;
};

export const getDisputeDueDateSetFilterTag = ({ value }) => {
  const date = parse(value, DEFAULT_YEAR_MONTH_DATE_FORMAT, new Date());
  const today = new Date();

  if (isSameDay(date, today)) {
    return "Due today";
  } else if (isSameDay(date, addDays(today, DAY_OFFSETS.TOMORROW))) {
    return "Due tomorrow";
  }
};
